import { z } from "zod";
import { canonicalJsonStringify } from "./canonical-json";

export const SkillPayloadSchema = z
  .object({
    schema_version: z.literal(1),
    authored_content: z.string(),
    rendered_content: z.string(),
    files: z.record(z.string(), z.string()),
  })
  .strict();
export type SkillPayload = z.infer<typeof SkillPayloadSchema>;
export function serializeSkillPayload(payload: SkillPayload): string {
  return canonicalJsonStringify(SkillPayloadSchema.parse(payload));
}

export const SkillPayloadReferenceSchema = z
  .object({
    id: z.string().nullable(),
    scope: z.enum(["global", "workspace", "agent"]),
    name: z.string().min(1),
    description: z.string(),
    reconstructed_from_revision: z
      .string()
      .regex(/^[a-f0-9]{40}$/)
      .optional(),
    authored_sha256: z.string().regex(/^[a-f0-9]{64}$/),
    content_sha256: z.string().regex(/^[a-f0-9]{64}$/),
    size_bytes: z
      .number()
      .int()
      .positive()
      .max(64 * 1024 * 1024),
  })
  .strict();
export type SkillPayloadReference = z.infer<typeof SkillPayloadReferenceSchema>;
